const SESSION_PARAM = 'creditPackSession'

// Stripe fills this placeholder in only when it stays literal; URLSearchParams would encode it.
const SESSION_PLACEHOLDER = '{CHECKOUT_SESSION_ID}'

/** Where Checkout sends the buyer back to: the page they bought on, with the session on success. */
export function creditPackReturnUrls(href: string): { successUrl: string; cancelUrl: string } {
  const url = new URL(href)
  url.searchParams.delete(SESSION_PARAM)
  url.hash = ''
  const cancelUrl = url.toString()
  const separator = url.search ? '&' : '?'
  return {
    successUrl: `${cancelUrl}${separator}${SESSION_PARAM}=${SESSION_PLACEHOLDER}`,
    cancelUrl,
  }
}

/** The pack session a return from Checkout carries, and the same address without it. */
export function creditPackReturn(href: string): { sessionId: string | null; cleanPath: string } {
  const url = new URL(href)
  const sessionId = url.searchParams.get(SESSION_PARAM)
  url.searchParams.delete(SESSION_PARAM)
  return { sessionId: sessionId || null, cleanPath: `${url.pathname}${url.search}${url.hash}` }
}
